import { render, staticRenderFns } from "./table.vue?vue&type=template&id=8528454c"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8528454c')) {
      api.createRecord('8528454c', component.options)
    } else {
      api.reload('8528454c', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=8528454c", function () {
      api.rerender('8528454c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/email-quarantine/table/table.vue"
export default component.exports